import { authHeader } from './auth';
import { wrapRequest } from './nav';
import { wrapGqlRequest } from "@/services/graphqlEndPointCommonSetting/wrapGqlRequest";
import { 
    CUSTOMER_STORE_CREDIT_QUERY, 
    transformStoreCreditDataToRest,
    GIFT_CARD_BALANCE_QUERY,
    REDEEM_GIFT_CARD_MUTATION,
    transformGiftCardDataToRest
} from "@/services/graphQl/store_credit.queries";
import { doFetchQuote } from '@/services/user_cart.service';

const vueAppMagenotApiUrl = import.meta.env.VITE_MAGENTO_API_URL;

export const doPostStoreCredit = async () => {
    const cartId = await doFetchQuote();
    const query = `
        mutation ApplyStoreCredit($cartId: String!) {
            applyStoreCreditToCart(input: { cart_id: $cartId }) {
                cart {
                    applied_store_credit {
                        applied_balance {
                            value
                            currency
                        }
                        current_balance {
                            value
                            currency
                        }
                        enabled
                    }
                }
            }
        }
    `;
    const response = await wrapGqlRequest(query, { cartId }, 'applyStoreCreditToCart');
    const appliedStoreCredit = response?.cart?.applied_store_credit;
    const mappedResponse = {
        applied_balance: appliedStoreCredit?.applied_balance || 0,
        current_balance: appliedStoreCredit?.current_balance || 0,
        enabled: appliedStoreCredit.enabled || 0
    };
    return mappedResponse;
};

export const doFetchStoreCreditGraphQL = async () => {
    try {
        const data = await wrapGqlRequest(CUSTOMER_STORE_CREDIT_QUERY, {}, "customer");
        
        if (data?.errors) {
            console.error('GraphQL errors:', data.errors);
            throw new Error(data.errors[0]?.message || 'Failed to fetch store credit data');
        }
        
        const storeCredit = data?.store_credit;
        if (!storeCredit) {
            return { balance: 0, currency: 'USD', enabled: false, history: [] };
        }
        
        return transformStoreCreditDataToRest(storeCredit);
    } catch (error) {
        console.error('Error fetching store credit via GraphQL:', error);
        throw error;
    }
};

export const doFetchGiftCardCreditBalanceGraphQL = async () => {
    try {
        const storeCreditData = await doFetchStoreCreditGraphQL();
        return storeCreditData.balance;
    } catch (error) {
        console.error('Error fetching store credit balance via GraphQL:', error);
        throw error;
    }
};

export const doFetchBalanceHistoryGraphQL = async () => {
    try {
        const storeCreditData = await doFetchStoreCreditGraphQL();
        return storeCreditData.history;
    } catch (error) {
        console.error('Error fetching balance history via GraphQL:', error);
        throw error;
    }
};

export const doFetchGiftCardBalanceGraphQL = async (giftCardCode) => {
    try {
        const variables = { input: { gift_card_code: giftCardCode } };
        const data = await wrapGqlRequest(GIFT_CARD_BALANCE_QUERY, variables, "giftCardAccount");
        
        if (data?.errors) {
            console.error('GraphQL errors:', data.errors);
            throw new Error(data.errors[0]?.message || 'Failed to fetch gift card balance');
        }
        
        if (!data) {
            throw new Error('Gift card not found or invalid code');
        }
        
        return data.balance?.value || 0;
    } catch (error) {
        console.error('Error fetching gift card balance via GraphQL:', error);
        throw error;
    }
};

export const doPostRedeemGiftCardGraphQL = async (giftCardCode) => {
    try {
        const variables = { input: { gift_card_code: giftCardCode } };
        const data = await wrapGqlRequest(REDEEM_GIFT_CARD_MUTATION, variables, "redeemGiftCardBalanceAsStoreCredit");
        
        if (data?.errors) {
            console.error('GraphQL errors:', data.errors);
            throw new Error(data.errors[0]?.message || 'Failed to redeem gift card');
        }
        
        if (!data) {
            throw new Error('Gift card redemption failed');
        }
        
        return transformGiftCardDataToRest(data);
    } catch (error) {
        console.error('Error redeeming gift card via GraphQL:', error);
        throw error;
    }
};
